import { useEffect, type RefObject } from "react";

export function useOuterClick(
  ref: RefObject<HTMLElement | null> | RefObject<HTMLElement | null>[],
  handler: () => void
) {
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      const refs = Array.isArray(ref) ? ref : [ref];
      const activeRefs = refs.filter(r => r.current);
      if (activeRefs.length === 0) return;
      const target = event.target;
      if (!(target instanceof Node)) return;
      const isOutside = activeRefs.every(r => !r.current?.contains(target));
      if (isOutside) {
        handler();
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, handler]);
}
